<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('units Coefficients')"
          :description="$t('from Here You Can Control Your Unit Transactions')"
        />
        <indexTable
          :searchText="$t('parameter Search')"
          :emptyTableText="$t('there Are No Transactions')"
          :localData="true"
          :buttonRole="$checkRole('products_add')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('name parameter'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: $checkRole('products_edit') },
                {
                  name: 'delete',
                  role: $checkRole('products_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/unitsCoefficients'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
